import { useTranslation } from "react-i18next";


const Map = ({ handleMap }) => {

    const { t } = useTranslation()



    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">

                                {/* {t('EncroachmentDashboard.Map')} */}
                                Track
                            </h5>
                            <button onClick={() => handleMap()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120976.5029023658!2d73.70974162209305!3d18.64083987010328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b85b3fffffff%3A0x5b68081c9bef7ac!2sPCMC%20Building!5e0!3m2!1sen!2sin!4v1720506711054!5m2!1sen!2sin" width="600" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>);
}

export default Map;